/*
 * From https://www.joshwcomeau.com/react/persisting-react-state-in-localstorage/
 * Modified by SB to allow states to be non-sticky in certain circumstances (e.g. if user hasn't accepted cookies)
 */
import { useState, useEffect } from 'react';

function useStickyState(defaultValue, key, {sticky=true, sessionOnly=false}={}) {
  const storage=sessionOnly?window.sessionStorage:window.localStorage;
  const [value, setValue] = useState(() => {
    const stickyValue = storage.getItem(key);
    return (sticky && stickyValue !== null)
      ? JSON.parse(stickyValue)
      : defaultValue;
  });
  useEffect(() => {
    if (sticky)
      storage.setItem(key, JSON.stringify(value));
  }, [key, value, sticky, storage]);
  return [value, setValue];
}

export default useStickyState;
